import { useHistory } from "react-router-dom";
import { Button } from "components/DesignSystem/Button/Button";
import Wind from "components/icons/Wind";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";

const BOOKS_CUSTOMERS_URL = "/books/revenue/customers";

type NexusTrackerEmptyStateProps = {
  onCheckPhysicalPresence: () => void;
};

export const NexusTrackerEmptyState = ({
  onCheckPhysicalPresence,
}: NexusTrackerEmptyStateProps) => {
  const { push } = useHistory();
  const { link } = useConstructInternalLink();

  const handleAddCustomer = () => {
    push(link(BOOKS_CUSTOMERS_URL));
  };

  return (
    <div className="t-flex t-flex-col t-items-center t-mt-40">
      <Wind className="t-text-text-30" />
      <p className="t-text-text-100 t-text-body t-font-medium t-mb-0 t-mt-4">
        No states tracked yet
      </p>
      <p className="t-text-text-30 t-text-body-sm t-mb-0 t-mt-1 t-text-center t-max-w-[450px]">
        Nexus tracking starts from your customers' billing addresses.
        <br /> Add a customer in Books and their state appears here, counting
        toward that state's threshold from the first invoice.
      </p>
      <div className="t-flex t-flex-wrap t-justify-center t-gap-2 t-mt-4">
        <Button
          customType="primary"
          size="small"
          onClick={onCheckPhysicalPresence}
        >
          I have a physical presence
        </Button>
        <Button customType="secondary" size="small" onClick={handleAddCustomer}>
          Add a customer
        </Button>
      </div>
    </div>
  );
};
